import React, { useEffect } from "react";
import { Grid, Card, Switch, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const OccupancyPermissionCard = (props) => {
  const { modules, setModules } = props;
  useEffect(() => {
    if (modules.Occupancy_view === undefined) {
      setModules((prevModules) => ({
        ...prevModules,
     Occupancy_view: false,
      }));
    }
  }, [modules, setModules]);

  const handleViewChange = (event) => {
    const isViewEnabled = event.target.checked;
    setModules({
      ...modules,
      Occupancy_view: isViewEnabled,
    });
  };
const isChecked = modules.Occupancy_view || false;
  return (
    <>
      <Card sx={{ minWidth: 275, boxShadow: 3 }}>
        <MDBox p={2}>
          <Grid container spacing={1}>
            <Grid item lg={12} md={12} xs={12} container alignItems="center">
              <MDTypography
                color="dark"
                display="block"
                variant="subtitle2"
                fontWeight="bold"
                sx={{ flex: 1 }}
              >
                Occupancy Module
              </MDTypography>

              <Tooltip
                title={`${
                 isChecked ? "Disable" : "Enable"
                } Occupancy module`}
                placement="top"
              >
                <Switch
                  checked={modules.Occupancy_view}
                  onChange={handleViewChange}
                />
              </Tooltip>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </>
  );
};

export default OccupancyPermissionCard;
